// extracted by mini-css-extract-plugin
export default {"buttonGroup":"buttonGroup---KwUFS","fullWidth":"fullWidth---XSCFU"};